'use strict';

export default class FourColContent {
  constructor() {


    // init controller
  var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1}});


    $(".introheading-stats").each(function(){
      if ( $(this).text().trim()) {
        var startScore = {score:0},
          scoreDisplay = $(this),
          stats = $(this);

        stats.data('endScore', stats.text());
        $(this).text('0')
        var increment = new TimelineMax()
          .to(startScore, 1, {score:stats.data('endScore'), roundProps:"score", onUpdate:updateHandler, ease:Power0.easeOut});

        new ScrollMagic.Scene({
          triggerElement: this,
          // reverse: false
        })
        .setTween(increment)
        .addTo(controller);


        function updateHandler()
        {
          scoreDisplay.text(startScore.score);
        }
      }
    })

    $('.four-column-content').each(function(){
      let hasStats = false;
      $(this).find('.introheading-stats').each(function(){
        if ($(this).text().trim()) {
          hasStats = true;
        }
      })
      if (!hasStats) {
        $(this).addClass('stats-hidden');
      }
    })
  }
}
